import { ManglaAartiAgainstDateModel, ManglaAartiFilterModel, ManglaAartiModel } from "../models/ManglaAartiModel";
import { ResponseModel } from "../models/ResponseModel";
import { AjaxService } from "../shared/services/AjaxService";


export const ManglaAartiService = {

    MANGLA_AARTI: {
        TEMPLE: 15,
        HOME_BEFORE_5: 10,
        HOME_AFTER_5: 5
    },

    async getAgainstDate(payload: ManglaAartiAgainstDateModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/ManglaAartis/getManglaArtisAgainstDate", payload);
    },

    async saveManglaAarti(payload: ManglaAartiModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/ManglaAartis/saveManglaArtis", payload);
    },

    async getManglaAartiHistory(payload: ManglaAartiFilterModel): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/ManglaAartis/getManglaAartiHistory", payload);
    },

    async getManglaAarti(manglaAartiId: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/ManglaAartis/getManglaAarti?manglaAartiId=${encodeURIComponent(manglaAartiId)}`);
    },

    async delete(manglaAartiId: string): Promise<ResponseModel> {
        return AjaxService.delete<ResponseModel>(`/ManglaAartis/delete?manglaArtiId=${encodeURIComponent(manglaAartiId)}`);
    },
}